import { render, staticRenderFns } from "./damagedPart.pug?vue&type=template&id=d1f45c2a&lang=pug&"
import script from "./damagedPart.js?vue&type=script&lang=js&"
export * from "./damagedPart.js?vue&type=script&lang=js&"
import style0 from "./damagedPart.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1f45c2a')) {
      api.createRecord('d1f45c2a', component.options)
    } else {
      api.reload('d1f45c2a', component.options)
    }
    module.hot.accept("./damagedPart.pug?vue&type=template&id=d1f45c2a&lang=pug&", function () {
      api.rerender('d1f45c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/multidamageList/components/damagedPart/index.vue"
export default component.exports